export type TimeUnit = 'second' | 'minute' | 'hour' | 'day' | 'week' | 'month' | 'year';

export type JustNowConfig = {
    justNowText?: string;
    justNowLimit?: number;
};

export const TIME_UNITS: TimeUnit[] = ['year', 'month', 'week', 'day', 'hour', 'minute', 'second'];

export const TIME_MULTIPLIERS: Record<Uppercase<TimeUnit>, number> = {
    YEAR: 365 * 24 * 60 * 60,
    MONTH: 30 * 24 * 60 * 60, // Approximate
    WEEK: 7 * 24 * 60 * 60,
    DAY: 24 * 60 * 60,
    HOUR: 60 * 60,
    MINUTE: 60,
    SECOND: 1,
};

export const UNIT_SUFFIX = 'PluralForms';
